import { render, staticRenderFns } from "./EventoParticipantes.vue?vue&type=template&id=2cf04c0c"
import script from "./EventoParticipantes.vue?vue&type=script&lang=js"
export * from "./EventoParticipantes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports